import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEN from './locales/en/common.json';
import commonJA from './locales/ja/common.json';
import { DEFAULT_LANG, LANGS, detectLangFromPath } from './utils/locale';

/**
 * 言語は URL の /en プレフィックスだけで決まり、ページ読み込み中に変わらない
 * （言語切替はフルロード）。そのため resources は静的 import のみとし、init を
 * 同期で完了させる。ページ固有のネームスペースは各 lazy ページが
 * addResourceBundle で自分の chunk から登録する。
 */
const lng = typeof window === 'undefined' ? DEFAULT_LANG : detectLangFromPath(window.location.pathname);

void i18n.use(initReactI18next).init({
  resources: {
    ja: { common: commonJA },
    en: { common: commonEN },
  },
  lng,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: [...LANGS],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

// プリレンダー済み HTML には正しい lang が入っているが、dev サーバーと
// SPA フォールバック経由では index.html の ja のままになる
if (typeof document !== 'undefined') {
  document.documentElement.lang = lng;
}

export default i18n;
